import { render } from "./DatasourcesList.vue?vue&type=template&id=41c10d30&scoped=true&ts=true"
import script from "./DatasourcesList.vue?vue&type=script&lang=ts"
export * from "./DatasourcesList.vue?vue&type=script&lang=ts"

import "./DatasourcesList.vue?vue&type=style&index=0&id=41c10d30&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c10d30"]])

export default __exports__